import { boxDataProps, doorDataProps, storeConfigurationState, windowDataProps } from '@/Interfaces/common';
import { Door } from '@/Engine/Door';
import { doorModelName } from '@/Constants/common';
import changeColor from '@/utils/changeColor';
import { Vector3 } from 'three';
import { useUIOnlyStore } from '@/Store/storeUI';
import { $ } from '@/Engine/state';
import { addWindow } from '@/Engine/addDoorAndWindow';
import { addBox } from '@/Engine/addBox';

export const updatePositionsUI = () => {
    const UIOnlyStore = useUIOnlyStore();
    if (UIOnlyStore.mode !== 1) return;
    const shift = 0.7;
    UIOnlyStore.setUIPosition('wallInput1', ...$.room.getWallHtmlCoords('front', shift));
    UIOnlyStore.setUIPosition('wallInput2', ...$.room.getWallHtmlCoords('left', shift));
    UIOnlyStore.setUIPosition('wallInput3', ...$.room.getWallHtmlCoords('right', shift));
    UIOnlyStore.setUIPosition('wallInput4', ...$.room.getWallHtmlCoords('back', shift));

    UIOnlyStore.setUIPosition2('centerLeft', ...$.room.getWallHtmlCoords('left', 0));
    UIOnlyStore.setUIPosition2('centerRight', ...$.room.getWallHtmlCoords('right', 0));
    UIOnlyStore.setUIPosition2('bottomCenter', ...$.room.getWallHtmlCoords('back', 0));
    UIOnlyStore.setUIPosition2('topRight', ...$.room.getWallHtmlCoords('frontRight', 0));
    UIOnlyStore.setUIPosition2('bottomLeft', ...$.room.getWallHtmlCoords('backLeft', 0));
    UIOnlyStore.setUIPosition2('bottomRight', ...$.room.getWallHtmlCoords('backRight', 0));
    UIOnlyStore.setUIPosition2('backRightWall', ...$.room.getWallHtmlCoords('backRightWall', 0));
};

export async function onStorageConfiguratorUpdate(state: storeConfigurationState) {
    await $.room.update(state.room);
    updatePositionsUI();
    $.wardrobe.update(state.wardrobe);
    $.wardrobe.setColor(state.wardrobeBaseColor);
    let i = $.doors.length;
    const doorUUIDs = state.wardrobe.doors.map((door: doorDataProps)=>door.uuid);
    while (i--) {
        if (!doorUUIDs.includes($.doors[i].uuid)) {
            $.doors[i].model.removeFromParent();
            $.doors.splice(i, 1);
        }
    }

    state.wardrobe.doors.forEach((doorData: doorDataProps) => {
        let door = $.doors.find((door) => door.uuid === doorData.uuid);
        if (!door) {
            door = new Door({
                uuid: doorData.uuid,
                width: doorData.width,
                height: doorData.height,
                name: doorModelName,
            });
        }
        if (!door) return;
        const doorModel = $.v3dTools.getObjectByName(doorModelName);
        if (doorModel)
            changeColor(doorModel, 'RGB', doorData.color);
        $.room.addToWall(door.model, doorData.side);
        // door._updateBox();
        // door.computeObb();
        door.setDimensions(doorData.width, doorData.height);
        door.position = (new Vector3(...doorData.position));

        $.doors.push(door);
    });

    const windowUUIDs = state.wardrobe.windows.map((window: windowDataProps)=>window.uuid);
    i = $.windows.length;
    while (i--) {
        if (!windowUUIDs.includes($.windows[i].uuid)) {
            $.windows[i].model.removeFromParent();
            $.windows.splice(i, 1);
        }
    }

    state.wardrobe.windows.forEach((windowData: windowDataProps) => {
        addWindow(windowData);
    });

    const boxUUIDs = state.wardrobe.boxes.map((box: boxDataProps)=>box.uuid);
    i = $.boxes.length;
    while (i--) {
        if (!boxUUIDs.includes($.boxes[i].uuid)) {
            $.boxes[i].model.removeFromParent();
            $.boxes.splice(i, 1);
        }
    }

    state.wardrobe.boxes.forEach((boxData: boxDataProps) => {
        addBox(boxData);
    });
}
